import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";

interface Props extends WithTranslation {
  timestamp: number;
  showErrorForPastTimes?: boolean;
}

class RelativeTimeClass extends React.Component<Props, {}> {

  interval: any = null;

  componentDidMount() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, 2000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const { timestamp, t, showErrorForPastTimes } = this.props;
    let className = "";
    if (showErrorForPastTimes && (Date.now() > timestamp)) {
      className = "error-text";
    }
    return (
      <span className={className}>{t ? t("relative", { value: timestamp }) : ""}</span>
    );
  }

}

export const RelativeTime = withTranslation()(RelativeTimeClass);
